"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.theme = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@radar-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = require("./theme");
var theme_2 = require("./theme");
Object.defineProperty(exports, "theme", { enumerable: true, get: function () { return theme_2.localTheme; } });
var HEADER_DESIDERED_HEIGHT = 60;
var headerVerticalPadding = 10;
var headerInnerHeight = HEADER_DESIDERED_HEIGHT - 2 * headerVerticalPadding;
/**
 * The logo width is fixed. So far we are happy with this, but
 * in case we will need a different width, we can see about inferring it?
 */
var Logo = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: url(", ") no-repeat;\n    background-size: contain;\n    height: ", "px;\n    width: 300px;\n    h1 {\n        margin: 0;\n        ", "\n    }\n"], ["\n    background: url(", ") no-repeat;\n    background-size: contain;\n    height: ", "px;\n    width: 300px;\n    h1 {\n        margin: 0;\n        ", "\n    }\n"])), function (p) { return p.path; }, headerInnerHeight, core_1.visuallyHidden);
var Wrapper = styled_components_1.default.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", "px 0;\n    border-bottom: 1px solid ", ";\n    background: ", ";\n"], ["\n    padding: ", "px 0;\n    border-bottom: 1px solid ", ";\n    background: ", ";\n"])), headerVerticalPadding, (0, theme_1.getValue)('header', 'border_color'), (0, theme_1.getValue)('header', 'background_color'));
var InnerHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 20px;\n    display: flex;\n    height: ", ";\n    align-items: center;\n"], ["\n    margin: 0 20px;\n    display: flex;\n    height: ", ";\n    align-items: center;\n"])), headerInnerHeight);
var Header = function (_a) {
    var logoAlt = _a.logoAlt, children = _a.children, logo = _a.logo, renderLogo = _a.renderLogo, className = _a.className, other = __rest(_a, ["logoAlt", "children", "logo", "renderLogo", "className"]);
    return (react_1.default.createElement(Wrapper, __assign({}, other, { className: (0, classnames_1.default)('rui-header', className) }),
        react_1.default.createElement(InnerHeader, { className: "rui-header-inner" },
            renderLogo ? renderLogo(logo, logoAlt) : react_1.default.createElement(Logo, { path: logo }, logoAlt && react_1.default.createElement("h1", null, logoAlt)),
            children)));
};
exports.Header = Header;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map